import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=762aa00c&scoped=true"
import script from "./UnderConstruction.vue?vue&type=script&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&lang=js"
import style0 from "./UnderConstruction.vue?vue&type=style&index=0&id=762aa00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762aa00c",
  null
  
)

export default component.exports